var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.3554,
    cy: 30.8485,
    r: 30.5741,
    fill: "#4C4D52"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.3557 18.2598C26.3911 18.2598 22.3633 22.241 22.3633 27.1445C22.3633 32.7866 28.3582 41.7278 30.5595 44.8161C30.6508 44.9464 30.7706 45.0525 30.909 45.1257C31.0473 45.1988 31.2004 45.2369 31.3557 45.2369C31.5109 45.2369 31.664 45.1988 31.8024 45.1257C31.9407 45.0525 32.0605 44.9464 32.1519 44.8161C34.3531 41.7291 40.348 32.7912 40.348 27.1445C40.348 22.241 36.3202 18.2598 31.3557 18.2598Z",
    stroke: "#33B1E9",
    strokeWidth: 1.79848,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3557 31.7486C33.3423 31.7486 34.9527 30.1382 34.9527 28.1516C34.9527 26.1651 33.3423 24.5547 31.3557 24.5547C29.3692 24.5547 27.7588 26.1651 27.7588 28.1516C27.7588 30.1382 29.3692 31.7486 31.3557 31.7486Z",
    stroke: "#33B1E9",
    strokeWidth: 1.79848,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/Icon (1).caa78a26a896ca82e2a4dbacb4c34bcf.svg";
export { ForwardRef as ReactComponent };